/**
 * v3 Budget channel tokens — local to /budget per the v3 prototype
 * (app.go-atrium.com → BAL palette). Distinct from lib/budget/channel-colors.ts
 * which mirrors the cross-app DashboardChannelTabs palette and must stay
 * untouched for other surfaces (one-page-one-branch rule).
 *
 * The hex values are the CSS-var equivalents declared in app/globals.css
 * (--color-ch-*). Re-emitted as constants here so React inline `style`
 * can read them without going through getComputedStyle.
 */

export interface ChannelTokenV3 {
  /** Solid hex used for left border, .anm color, slider thumb. */
  hex: string
  /** 135deg two-stop gradient used for the .atile icon tile. */
  gradient: string
  /** Display label. */
  label: string
}

export const CH_TOKENS_V3: Record<string, ChannelTokenV3> = {
  search: {
    hex: '#A8780C',
    gradient: 'linear-gradient(135deg, #E0A82E, #FFD95C)',
    label: 'Search',
  },
  social: {
    hex: '#2D6CDF',
    gradient: 'linear-gradient(135deg, #2D6CDF, #7FB0FF)',
    label: 'Social',
  },
  tv: {
    hex: '#7A5BD6',
    gradient: 'linear-gradient(135deg, #7A5BD6, #B9A6FF)',
    label: 'TV / CTV',
  },
  programmatic: {
    hex: '#0A8A6E',
    gradient: 'linear-gradient(135deg, #0A8A6E, #2BC39A)',
    label: 'Programmatic',
  },
  audio: {
    hex: '#E0762D',
    gradient: 'linear-gradient(135deg, #E0762D, #FFB36B)',
    label: 'Audio',
  },
  retail: {
    hex: '#C2185B',
    gradient: 'linear-gradient(135deg, #FF8FB0, #FFC2D4)',
    label: 'Retail',
  },
}

export const CH_TOKEN_V3_FALLBACK: ChannelTokenV3 = {
  hex: '#6b7280',
  gradient: 'linear-gradient(135deg, #9ca3af, #d1d5db)',
  label: 'Other',
}

export function getChannelTokenV3(channelKey: string): ChannelTokenV3 {
  return CH_TOKENS_V3[channelKey] ?? CH_TOKEN_V3_FALLBACK
}
